import React, { useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";

const Login: React.FC = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [backendStatus, setBackendStatus] = React.useState<
    "checking" | "online" | "offline"
  >("checking");

  useEffect(() => {
    checkBackendStatus();
    // Process token in URL if present (OAuth callback)
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      // store token and redirect to dashboard
      localStorage.setItem("token", token);
      // simple navigation - actual profile fetch handled elsewhere in app
      navigate("/dashboard");
    }
  }, []);

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  const checkBackendStatus = async () => {
    try {
      const response = await fetch("/api/health");
      setBackendStatus(response.ok ? "online" : "offline");
    } catch (e) {
      setBackendStatus("offline");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          minHeight: "80vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%", textAlign: "center" }}>
          <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
            <img
              src="/logo.png"
              alt="University of Vavuniya Logo"
              style={{ maxWidth: "150px", height: "auto" }}
            />
          </Box>
          <Typography variant="h5" gutterBottom>
            Welcome to University of Vavuniya Leave Management System
          </Typography>

          {backendStatus === "checking" && (
            <Alert severity="info">Checking backend connection...</Alert>
          )}
          {backendStatus === "offline" && (
            <Alert severity="error">
              Backend offline please contact support@vau.ac.lk
            </Alert>
          )}

          <Box sx={{ mt: 3 }}>
            <Button
              variant="outlined"
              onClick={() => authService.googleLogin()}
              fullWidth
            >
              <Box component="span" sx={{ mr: 1, display: "inline-flex" }}>
                <svg width="18" height="18" viewBox="0 0 48 48">
                  <path
                    fill="#EA4335"
                    d="M24 9.5c3.9 0 7.1 1.4 9.4 3.4l7-7C35.3 2 29.9 0 24 0 14.7 0 6.9 5.3 3.3 12.9l8.2 6.4C13.9 15 18.4 9.5 24 9.5z"
                  />
                  <path
                    fill="#34A853"
                    d="M46.5 24c0-1.6-.1-3.1-.4-4.6H24v9h12.7c-.5 2-1.8 3.7-3.7 4.8l5.6 4.3C44.6 36.6 46.5 30.6 46.5 24z"
                  />
                  <path
                    fill="#4A90E2"
                    d="M11.5 28.6A14.5 14.5 0 0 1 12 24c0-1.3.2-2.6.5-3.8L4.3 13.8A23.9 23.9 0 0 0 0 24c0 3.8.9 7.4 2.6 10.6l8.9-6z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M24 48c6.5 0 12-2.1 16-5.6l-7.6-5.8c-2 1.4-4.6 2.3-8.4 2.3-5.5 0-10-3.5-11.6-8.3L3.3 35.1C6.9 42.7 14.7 48 24 48z"
                  />
                </svg>
              </Box>
              Sign in with University of Vavuniya G Suit Email
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
